module.exports = __webpack_public_path__ + "static/media/Thumbnail.1db65bdc.jpg";